import 'selectize/dist/js/selectize.js';

'use strict';

var ad_select = function () {
  var self = this;

  self.init();
  self.bind();
};

ad_select.prototype.init = function () {
  var self = this;

  // console.log('init ad_select');

  self.init_single();
  self.init_multiple();
  self.init_groups();
  self.init_tagging();


  self.REGEX_EMAIL = '([a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@' +
                    '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)';

  self.init_mail();

};


ad_select.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_select');

  jQuery(document).arrive('.ad_select.ad_select_single', self.init_single);
  jQuery(document).arrive('.ad_select.ad_select_multiple', self.init_multiple);
  jQuery(document).arrive('.ad_select.ad_select_groups', self.init_groups);
  jQuery(document).arrive('.ad_select.ad_select_tagging', self.init_tagging);
  jQuery(document).arrive('.ad_select.ad_select_mail', self.init_mail);

};

ad_select.prototype.init_single = function () {
  //var self = this;

  jQuery('.ad_select.ad_select_single').each(function (/*index*/) {
    var element = jQuery(this);

    var selectize = element.find('select');

    if (element.hasClass('st_mounted') === false) {

      var add_enabled = false;

      if (element.hasClass('add_enabled') ) {
        add_enabled = true;
      }

      selectize.selectize({
        create: add_enabled,
        copyClassesToDropdown: false,
        sortField: '$order'
      });

      element.addClass('st_mounted');
    }

  });

};

ad_select.prototype.init_multiple = function () {
  //var self = this;

  jQuery('.ad_select.ad_select_multiple').each(function (/*index*/) {
    var element = jQuery(this);

    var selectize = element.find('select');

    if (element.hasClass('st_mounted') === false) {

      var add_enabled = false;

      if (element.hasClass('add_enabled') ) {
        add_enabled = true;
      }

      selectize.selectize({
        create: add_enabled,
        hideselected: true,
        plugins: ['remove_button'],
        sortField: '$order'
      });

      element.addClass('st_mounted');
    }

  });

};


ad_select.prototype.init_groups = function () {
  //var self = this;

  jQuery('.ad_select.ad_select_groups').each(function (/*index*/) {
    var element = jQuery(this);

    var selectize = element.find('select');

    if (element.hasClass('st_mounted') === false) {
      selectize.selectize({
        sortField: '$order'
      });

      element.addClass('st_mounted');
    }

  });

};


ad_select.prototype.init_tagging = function () {
  //var self = this;

  jQuery('.ad_select.ad_select_tagging').each(function (/*index*/) {
    var element = jQuery(this);

    var selectize = element.find('input');

    if (element.hasClass('st_mounted') === false) {
      selectize.selectize({
        delimiter: ',',
        persist: false,
        plugins: ['remove_button'],
        create: function(input) {
            return {
                value: input,
                text: input
            };
        },
        sortField: '$order'
      });

      element.addClass('st_mounted');
    }

  });

};


ad_select.prototype.init_mail = function () {
  //var self = this;

  jQuery('.ad_select.ad_select_mail').each(function (/*index*/) {
    var element = jQuery(this);

    var selectize = element.find('select');

    if (element.hasClass('st_mounted') === false) {
      selectize.selectize({
        persist: false,
        maxItems: null,
        valueField: 'email',
        labelField: 'name',
        searchField: ['name', 'email'],
        sortField: '$order',
        options: [
            {email: 'brian@thirdroute.com', name: 'Brian Reavis'},
            {email: 'nikola@tesla.com', name: 'Nikola Tesla'},
            {email: 'someone@gmail.com'}
        ],
        render: {
            item: function(item, escape) {
                return '<div>' +
                    (item.name ? '<span class="name">' + escape(item.name) + '</span>' : '') +
                    (item.email ? '<span class="email">' + escape(item.email) + '</span>' : '') +
                '</div>';
            },
            option: function(item, escape) {
                var label = item.name || item.email;
                var caption = item.name ? item.email : null;
                return '<div>' +
                    '<span class="label">' + escape(label) + '</span>' +
                    (caption ? '<span class="caption">' + escape(caption) + '</span>' : '') +
                '</div>';
            }
        },
        createFilter: function(input) {
            var match, regex;

            // email@address.com
            regex = new RegExp('^' + window.ad_select.REGEX_EMAIL + '$', 'i');
            match = input.match(regex);
            if (match) {
              return !this.options.hasOwnProperty(match[0]);
            }

            // name <email@address.com>
            regex = new RegExp('^([^<]*)\<' + window.ad_select.REGEX_EMAIL + '\>$', 'i');
            match = input.match(regex);
            if (match) {
              return !this.options.hasOwnProperty(match[2]);
            }

            return false;
        },
        create: function(input) {
            if ((new RegExp('^' + window.ad_select.REGEX_EMAIL + '$', 'i')).test(input)) {
                return {email: input};
            }
            var match = input.match(new RegExp('^([^<]*)\<' + window.ad_select.REGEX_EMAIL + '\>$', 'i'));
            if (match) {
                return {
                  email: match[2],
                  name: jQuery.trim(match[1])
                };
            }
            // console.log('Invalid email address.');
            return false;
        }









      });

      element.addClass('st_mounted');
    }

  });

};




jQuery( document ).ready(function() {

  window.ad_select = new ad_select();

});
